<template>
  <div class="city_select" @mousedown.capture.prevent.stop style="border-radius: 8px">
<!--    <div class="search_history" v-if="!showFilter && cityHistory().length">-->
<!--      <div class="header_box">-->
<!--        <span>最近搜索记录</span>-->
<!--        <span @click="clearCityHistory()">清除记录</span>-->
<!--      </div>-->
<!--      <div :class="regionId === 1 ? 'content_box' : 'content_box_ov'">-->
<!--        <div class="history_item" v-for="(item, index) in cityHistory()" :key="index" @click="selFilterCity(item)">-->
<!--          <i class="iconfont icon-B1BECF" style="color: #b1becf" v-if="regionId === 2"/>-->
<!--          <span>{{ item.cityName }}</span>-->
<!--          <span v-if="item.provinceNameCn && regionId === 2">, {{ item.provinceNameCn }}</span>-->
<!--          <span v-if="item.country_name_cn && regionId === 2">, {{ item.country_name_cn }}</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div v-loading="!hasData" :style="!hasData ? 'height: 300px;' : ''">
      <div class="region_Chian" v-show="!showFilter && regionId === 1"
        :style="isLang ? 'min-width: 835px;' : ''">
        <div class="header_title" v-if="hasData">
          <div @click="changeTitle('hot')" :class="isSelTitle('hot') ? 'sel' : ''">{{ $t('search.hot_chain') }}</div>
          <div @click="changeTitle('ABCD')" :class="isSelTitle('ABCD') ? 'sel' : ''">ABCD</div>
          <div @click="changeTitle('EFGH')" :class="isSelTitle('EFGH') ? 'sel' : ''">EFGH</div>
          <div @click="changeTitle('IJKL')" :class="isSelTitle('IJKL') ? 'sel' : ''">IJKL</div>
          <div @click="changeTitle('MNOP')" :class="isSelTitle('MNOP') ? 'sel' : ''">MNOP</div>
          <div @click="changeTitle('QRST')" :class="isSelTitle('QRST') ? 'sel' : ''">QRST</div>
          <div @click="changeTitle('UVWX')" :class="isSelTitle('UVWX') ? 'sel' : ''">UVWX</div>
          <div @click="changeTitle('YZ')" :class="isSelTitle('YZ') ? 'sel' : ''">YZ</div>
        </div>
        <div class="hot_city">
          <div v-for="(i, key2, index2) of showCityList" :key="index2" class="city_item"
            :style="isLang ? 'grid-template-columns: repeat(6, max-content);' : ''">
            <div v-if="i.length" v-text="key2 == 'hot' ? '' : key2" :style="isLang ? 'grid-column-end: 7;' : ''"></div>
            <div v-for="(x, index3) in i" :key="index3" class="sel_item" @mouseenter="enterOne(x)"
              @mouseleave="leaveOne(x)" @click="selOne(x, 1)" :class="x.show ? 'enter_one' : ''">
              <span v-html="isLang ? x.pinyin.toLowerCase() : x.cityName"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="region_oversea" v-show="!showFilter && regionId === 2"
        :style="isLang ? 'min-width: 835px;' : ''">
        <div class="header_title" v-if="hasData">
          <div @click="changeOverseaTitle('hot')" :class="isOverseaTitle('hot') ? 'sel' : ''">{{
            $t('search.hot_oversea')
          }}</div>
          <div @click="changeOverseaTitle('东南亚')" :class="isOverseaTitle('东南亚') ? 'sel' : ''">{{
            $t('search.southeast_asia')
          }}</div>
          <div @click="changeOverseaTitle('亚洲')" :class="isOverseaTitle('亚洲') ? 'sel' : ''">{{ $t('search.Asia') }}
          </div>
          <div @click="changeOverseaTitle('美洲')" :class="isOverseaTitle('美洲') ? 'sel' : ''">{{ $t('search.America') }}
          </div>
          <div @click="changeOverseaTitle('欧洲')" :class="isOverseaTitle('欧洲') ? 'sel' : ''">{{ $t('search.Europe') }}
          </div>
          <div @click="changeOverseaTitle('大洋洲')" :class="isOverseaTitle('大洋洲') ? 'sel' : ''">{{
            $t('search.Oceanica')
          }}
          </div>
          <div @click="changeOverseaTitle('中东/非洲')" :class="isOverseaTitle('中东/非洲') ? 'sel' : ''">{{
            $t('search.middle_east_africa')
          }}</div>
        </div>
        <div class="hot_city_oversea">
          <div v-for="(item, index) in showOverseaCityList" :key="index" class="city_item"
            :style="isLang ? 'grid-template-columns: repeat(6, max-content);' : ''">
            <div v-for="(i, ind) in item" :key="ind" @mouseenter="enterOne(i)" @mouseleave="leaveOne(i)"
              @click="selOne(i, 2)" :class="i.show ? 'enter_one' : ''">
              <span v-html="isLang ? i.pinyin : i.cityName"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="city_list_box" v-show="showFilter">
        <div v-if="filterCityData.length">
          <div class="city_filter_item" v-for="(item, index) in filterCityData" :key="index" @click="selFilterCity(item)">
            <img src="@/assets/newImage/city.png" alt="">
            <span>
              <span style="font-weight: 600;" v-html="isLang ? item.pinyin : item.cityName"></span>
              <span v-if="!isLang">
                <span v-if="item.provinceNameCn && item.country_name_cn !== '中国'">, {{ item.provinceNameCn }}</span>
                <span v-if="item.country_name_cn">, {{ item.country_name_cn }}</span>
              </span>
            </span>
            <span v-html="isLang ? 'city' : '城市'"></span>
          </div>
        </div>
        <div v-else class="none_city">
          <div class="none_box">
            <img src="@/assets/img/hotel-search-no.png" alt="">
            <p>暂无匹配城市</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cityData: {},
      overseaCityData: {},
      key: 'hot',
      overseaKey: 'hot',
      filterCityData: [],
      isClickInputCity: false,
      // allCityList: [],
      accountType: 3,
      hasData: false
    }
  },
  props: {
    show: {
      show: Boolean,
      default: false
    },
    showFilter: {
      showFilter: Boolean,
      default: false
    },
    keyword: {
      keyword: String,
      default: ''
    },
    regionId: {
      type: Number,
      default: 1
    }
  },
  created () {
    this.getCityData()
    if (this.$common.getAccountType()) {
      this.accountType = this.$common.getAccountType();
    }
  },
  methods: {
    changeTitle (e) {
      this.key = e
    },
    changeOverseaTitle (e) {
      this.overseaKey = e
    },
    async getCityData () {
      const { data: result } = await this.$http.get('../../../../../static/mock/citySelect.json')
      const { data: overseaResult } = await this.$http.get('../../../../../static/mock/cityOverseaSelect.json')
      // const { data: allCity } = await this.$http.get('../../../../../static/mock/citysData.json')
      this.cityData = result
      this.overseaCityData = overseaResult
      // this.allCityList = allCity
      this.hasData = true
    },
    isSelTitle (e) {
      return this.key == e;
    },
    isOverseaTitle (e) {
      return this.overseaKey == e;
    },
    enterOne (e) {
      this.$set(e, 'show', true)
    },
    leaveOne (e) {
      this.$set(e, 'show', false)
    },
    selOne (e, regionId) {
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (homeSearchForm) {
        homeSearchForm.cityInfo = e
        homeSearchForm.name = e.cityName
        homeSearchForm['regionId'] = regionId
        sessionStorage.setItem('homeSearchForm', JSON.stringify(homeSearchForm))
      }
      e['regionId'] = regionId
      this.saveHistory(e)
      this.$emit('selCity', { ...e })
    },
    saveHistory (e) {
      let regionId = e.cityCode.indexOf('KK') !== -1 ? 2 : 1
      let key = regionId === 1 ? 'citySearchHistoryCn' : 'citySearchHistoryEn'
      let history = localStorage.getItem(key)
      if (history) {
        let historyArr = JSON.parse(history)
        let exist = historyArr.some(item => item.cityCode === e.cityCode)
        if (!exist) {
          historyArr.unshift(e)
        }
        if (historyArr.length > 5) {
          historyArr.pop()
        }
        localStorage.setItem(key, JSON.stringify(historyArr))
      } else {
        localStorage.setItem(key, JSON.stringify([e]))
      }
    },
    selFilterCity (e) {
      this.saveHistory(e)
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (homeSearchForm) {
        homeSearchForm.cityInfo = e
        homeSearchForm.name = e.cityName
        if (e.cityCode.indexOf('KK') != -1) {
          homeSearchForm.regionId = 2
          e['regionId'] = 2
        } else {
          homeSearchForm.regionId = 1
          e['regionId'] = 1
        }
        sessionStorage.setItem('homeSearchForm', JSON.stringify(homeSearchForm))
      } else {
        let formData = {
          cityInfo: e,
          name: e.cityName,
        }
        if (e.cityCode.indexOf('KK') != -1) {
          formData.regionId = 2
          e['regionId'] = 2
        } else {
          formData.regionId = 1
          e['regionId'] = 1
        }
        sessionStorage.setItem('homeSearchForm', JSON.stringify(formData))
      }
      this.isClickInputCity = true
      this.$emit('selFilterCity', { ...e })
    },
    cityHistory () {
      let key = this.regionId === 1 ? 'citySearchHistoryCn' : 'citySearchHistoryEn'
      let history = localStorage.getItem(key)
      return history ? JSON.parse(history) : []
    },
    clearCityHistory () {
      let key = this.regionId === 1 ? 'citySearchHistoryCn' : 'citySearchHistoryEn'
      localStorage.removeItem(key)
      this.$emit('blurInput')
    }
  },
  computed: {
    showCityList () {
      return this.key == 'hot' ? this.cityData['热门'] : this.cityData[this.key]
    },
    showOverseaCityList () {
      return this.overseaKey == 'hot' ? this.overseaCityData['热门'] : this.overseaCityData[this.overseaKey]
    },
    isLang () {
      return localStorage.getItem('lang') == 'en'
    }
  },
  watch: {
    async keyword (val) {
      this.filterCityData = [];
      if (!val) return
      let headers = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      const { data: result } = await this.$http.get(`/mini/getCurrentCity?keyWord=${val}&regionId=${this.regionId}`, { headers })
      if (result.code != 200) return
      let esCities = []
      result.data.forEach(item => {
        esCities.push({
          cityCode: item.cityCode,
          cityName: item.cityNameCn,
          pinyin: item.cityName,
          country_name: item.countryName,
          country_name_cn: item.countryNameCn,
          provinceName: item.provinceName,
          provinceNameCn: item.provinceNameCn
        })
      })

      let resultArr = esCities
      // 粗过滤与关键词匹配的城市
      // esCities.forEach(item => {
      //   if (this.isLang) {
      //     if (item.pinyin && item.pinyin.indexOf(val) != -1) {
      //       resultArr.push(item)
      //     }
      //   } else {
      //     if (item.cityName && item.cityName.indexOf(val) != -1) {
      //       resultArr.push(item)
      //     }
      //   }
      // })
      let chainCity = []
      let overseaCity = []
      // 国内海外城市排序
      resultArr.forEach(item => {
        if (item.country_name_cn == '中国大陆') {
          chainCity.push(item)
        } else {
          overseaCity.push(item)
        }
      })
      // 获取国内省份名称
      chainCity.forEach(item => {
        for (let key in this.cityData) {
          if (key != '热门') {
            for (let i in this.cityData[key]) {
              this.cityData[key][i].forEach(x => {
                if (x.cityCode == item.cityCode) {
                  this.$set(item, 'provinceName', x.provinceName)
                }
              })
            }
          }
        }
      })
      // 根据账号类型过滤用户搜索的城市
      if (this.accountType == 1) {
        this.filterCityData = chainCity
      } else if (this.accountType == 2) {
        this.filterCityData = overseaCity
      } else if (this.accountType == 3) {
        this.filterCityData = [...chainCity, ...overseaCity]
      } else {
        this.filterCityData = []
      }
    }
  }
}
</script>

<style  lang="less" scoped>
.city_select {
  height: 250px;
  width: 835px;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0 2px 2px #eaeaea;
  z-index: 50;
  padding-bottom: 10px;

  .region_Chian {
    .header_title {
      height: 30px;
      line-height: 30px;
      background-color: #f5f6f9;
      display: grid;
      grid-template-columns: repeat(8, auto);

      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #666666;

      .sel {
        color: #1e50f0;
      }
    }

    .hot_city {

      .city_item {
        display: grid;
        grid-template-columns: repeat(7, max-content);
        grid-column-gap: 8px;
        padding: 0 15px;

        div:first-child {
          grid-column-start: 1;
          grid-column-end: 8;
          margin-top: 10px;
          font-size: 14px;
        }

        .sel_item {
          min-width: 95px;
          height: 30px;
          line-height: 30px;
          padding: 0 6px;
          font-size: 13px;
        }

        .enter_one {
          background-color: #1e50f0;
          color: #fff;
        }
      }
    }
  }

  .region_oversea {
    //margin-top: 10px;

    .header_title {
      height: 30px;
      line-height: 30px;
      background-color: #f5f6f9;
      display: grid;
      grid-template-columns: repeat(7, auto);
      grid-column-gap: 15px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #666666;

      .sel {
        color: #1e50f0;
      }
    }

    .hot_city_oversea {
      .city_item {
        display: grid;
        grid-template-columns: repeat(7, max-content);
        grid-column-gap: 8px;
        padding: 0 15px;
        margin-top: 10px;

        div {
          min-width: 95px;
          height: 30px;
          line-height: 30px;
          padding: 0 6px;
          font-size: 13px;
        }

        .enter_one {
          background-color: #1e50f0;
          color: #fff;
        }
      }
    }
  }

  .city_list_box {
    min-width: 280px;
    font-family: '苹方';

    .city_filter_item {
      min-height: 40px;
      padding: 0 8px;
      border-left: 3px solid #fff;
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      grid-column-gap: 8px;

      &:hover {
        border-left: 3px solid #1e50f0;
        background-color: #f5f6f9;
      }
    }
  }

  .none_city {
    text-align: center;

    .none_box {
      padding-left: 40px;
    }
  }
}

.search_history {
  .header_box {
    background-color: #f5f6f9;
    height: 25px;
    line-height: 25px;
    font-size: 15px;
    padding: 0 10px;
    color: #1e50f0;
    display: flex;
    justify-content: space-between;
  }

  .content_box {
    display: flex;
    padding: 15px 20px;
    column-gap: 15px;

    .history_item {
      display: flex;
      align-items: center;
      padding: 8px 16px;
      background-color: #d7d7d7;
      border-radius: 4px;

      &:hover {
        color: #fff;
        background-color: #1e50f0;
      }
    }
  }

  .content_box_ov {
    padding: 15px 10px;

    .history_item {
      padding: 10px;

      &:hover {
        color: #fff;
        background-color: #1e50f0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/CitySelect.vue